import { useState } from 'react';

import { useAvailablePeriod } from '@entities/available-periods';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import parseISO from 'date-fns/parseISO';

import { xhr } from '@shared/config';

import { useConsultation } from '@src/entities/consultations';

export const useChangeTime = (
	consultationId: number,
	availablePeriodId: number,
	onSuccess: () => void
) => {
	const { consultation } = useConsultation(consultationId);
	const { availablePeriod } = useAvailablePeriod(availablePeriodId);

	const [loading, setLoading] = useState(false);

	const onChange = async () => {
		if (!availablePeriod || !consultation) return;

		setLoading(true);

		try {
			const data = {
				origin_schedule: consultation.schedule.id,
				start_time: availablePeriod.start_time,
				duration: differenceInMinutes(
					parseISO(consultation.end_time),
					parseISO(consultation.start_time)
				),
				reason_to_change: '',
			};

			const res = await xhr.post(`/api/v1/schedules/change_time/`, data);

			if (!res.data) throw res;

			if (onSuccess) onSuccess();
		} catch (error) {
			console.log(error);
		}

		setLoading(false);
	};

	return {
		onChange,
		loading,
	};
};
